export default {
    adjustments: {
        title: "Ajustes",
        reset: "Reiniciar",
        light: {
            title: "Luz",
            brightness: "Brilho",
            contrast: "Contraste",
            shadows: "Sombras",
        },
        color: {
            title: "Cor",
            saturation: "Saturação",
            temperature: "Temperatura",
            blacks: "Negros",
            whites: "Brancos",
        },
        detail: {
            title: "Detalhe",
            clarity: "clareza",
            sharpness: "Nitidez",
            blur: "Borrar",
        },
    },
};
